import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { Button } from './ui/button';
import { businessInfo } from '../mock';

export const Header = ({ onContactClick }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    if (!isHomePage) {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          const offset = 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;
          window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(id);
      if (element) {
        const offset = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
      }
    }
    setIsMobileMenuOpen(false);
  };

  const handleHomeClick = () => {
    navigate('/');
    setIsMobileMenuOpen(false);
  };

  const navItems = [
    { label: 'Home', id: 'hero' },
    { label: 'About', id: 'about' },
    { label: 'Services', id: 'services' },
    { label: 'Process', id: 'process' },
    { label: 'Pricing', id: 'pricing' },
    { label: 'FAQs', id: 'faqs' },
    { label: 'Contact', id: 'contact' }
  ];

  return (
    <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-[#3E2723] shadow-lg' : 'bg-[#3E2723]/95 backdrop-blur-sm'
      }`}>
        {/* Top bar */}
        <div className="bg-[#8D6E63] text-white py-2 px-4 md:px-8">
          <div className="max-w-7xl mx-auto flex flex-wrap justify-between items-center text-sm gap-2">
            <div className="flex items-center gap-4">
              <a href={`tel:${businessInfo.phone}`} className="flex items-center gap-1 hover:text-[#D7CCC8] transition-colors">
                <Phone className="w-3 h-3" />
                <span>{businessInfo.phone}</span>
              </a>
              <a href={`mailto:${businessInfo.email}`} className="flex items-center gap-1 hover:text-[#D7CCC8] transition-colors">
                <Mail className="w-3 h-3" />
                <span className="hidden sm:inline">{businessInfo.email}</span>
              </a>
            </div>
            <div className="text-xs md:text-sm">
              USPTO Filing Experts | 1000+ Trademarks Filed
            </div>
          </div>
        </div>

        {/* Main navigation */}
        <nav className="max-w-7xl mx-auto px-4 md:px-8 py-4">
          <div className="flex items-center justify-between">
            <button onClick={handleHomeClick} className="flex items-center gap-3 cursor-pointer">
              <img 
                src="/logo-white.png" 
                alt="TradeMark Registry Logo" 
                className="h-12 md:h-14 w-auto object-contain"
              />
            </button>

            {/* Desktop menu */}
            <div className="hidden lg:flex items-center gap-6">
              {navItems.map(item => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="text-white hover:text-[#D7CCC8] transition-colors duration-300 font-medium"
                >
                  {item.label}
                </button>
              ))}
              <Button
                onClick={onContactClick}
                className="bg-[#D7CCC8] text-[#3E2723] hover:bg-white transition-colors duration-300 font-semibold"
              >
                Get Started
              </Button>
            </div>

            {/* Mobile menu button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden text-white p-2"
            >
              {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </nav>
      </header>

      {/* Mobile menu */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-40 bg-[#3E2723] pt-32 lg:hidden">
          <div className="flex flex-col items-center gap-6 p-8">
            {navItems.map(item => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-white text-xl hover:text-[#D7CCC8] transition-colors duration-300"
              >
                {item.label}
              </button>
            ))}
            <Button
              onClick={() => {
                onContactClick();
                setIsMobileMenuOpen(false);
              }}
              className="bg-[#D7CCC8] text-[#3E2723] hover:bg-white transition-colors duration-300 font-semibold mt-4"
            >
              Get Started
            </Button>
          </div>
        </div>
      )}
    </>
  );
};
